import { getPatternStyles, patternFns } from '../helpers.js';
import { css } from '../css/index.js';

const textConfig = {
transform:({ style, bold, align, shadow, italic, ...rest }) => ({
  textStyle: style,
  textAlign: align,
  textShadow: shadow,
  fontWeight: bold ? "bold" : void 0,
  fontStyle: italic ? "italic" : void 0,
  ...rest
})}

export const getTextStyle = (styles = {}) => {
  const _styles = getPatternStyles(textConfig, styles)
  return textConfig.transform(_styles, patternFns)
}

export const text = (styles) => css(getTextStyle(styles))
text.raw = getTextStyle